import axiosConfig from './axiosConfig'
import utils from './utils'
const HTTP = axiosConfig.HTTP

// state
const state = {
  codPlantilla: null,
  loadingTemplateDetails: false,
  lang: 'ES',
  loadingCuponesCount: false,
  couponType: 'T',
  idclient: '',
  tipidcli: '',
  nombre: '',
  apellid1: '',
  apellid2: '',
  canalusof: '',
  codplantilla1: '',
  codplantilla2: '',
  codplantilla3: '',
  codplantilla4: '',
  codplantilla5: '',
  advancedSearch: {},
  reloadAccountsToAssign: false,
  reloadCoupons: false,
  reloadCouponsCount: false,
  loadingCuponesTable: false,
  loadingCLCAC: false,
  loadingALACU: false,
  loadingCLPCP: false
}

// getters
const getters = {
  couponsBussy () {
    if (state.loadingTemplateDetails || state.loadingCuponesCount ||
        state.loadingCuponesTable || state.loadingCLCAC) {
      return true
    } else {
      return false
    }
  },
  isReloadAccountsToAssign () {
    return state.reloadAccountsToAssign
  },
  isReloadCoupons () {
    return state.reloadCoupons
  },
  isReloadCouponsCount () {
    return state.reloadCouponsCount
  },
  getAdvancedSearch () {
    return state.advancedSearch
  },
  getCodPlantilla () {
    return state.loadingCuponesCount
  },
  isloadingTemplateDetails () {
    return state.loadingTemplateDetails
  },
  isloadingCLPCP () {
    return state.loadingCLPCP
  },
  getloadingCuponesCount () {
    return state.loadingCuponesCount
  },
  getTypeCoupon () {
    return state.couponType
  },
  getIdclient () {
    return state.idclient
  },
  getTipidcli () {
    return state.tipidcli
  },
  getNombre () {
    return state.nombre
  },
  getApellid1 () {
    return state.apellid1
  },
  getApellid2 () {
    return state.apellid2
  },
  getCanal () {
    return state.canalusof
  },
  getCodplantilla1 () {
    return state.codplantilla1
  },
  getCodplantilla2 () {
    return state.codplantilla2
  },
  getCodplantilla3 () {
    return state.codplantilla3
  },
  getCodplantilla4 () {
    return state.codplantilla4
  },
  getCodplantilla5 () {
    return state.codplantilla5
  },
  isloadingCuponesTable () {
    return state.loadingCuponesTable
  },
  isloadingALACU () {
    return state.loadingALACU
  },
  isloadingCLCAC () {
    return state.loadingCLCAC
  }
}

// actions
const actions = {
  async assignCouponALACU ({ commit, rootState }, dat) {
    commit('SET_LOADING_ALACU', true)
    const data = await dat
    console.log('assignCouponALACU data', data)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const codPlantilla = state.codPlantilla
    const appProgram = sessionStorage.getItem('appProgram')
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(appParams.entidad + storageAppToken + appParams.canal)
    const body = {
      runService: {
        opData: {
          avanzar: false,
          businesstimeout: '',
          canal: config.canal,
          claveFin: data && data.claveFin ? data.claveFin : 20,
          claveInicio: data && data.claveInicio ? data.claveInicio : 1,
          entidad: config.entidad,
          idioma: state.lang.toUpperCase(),
          indMasDatos: data && data.indMasDatos ? data.indMasDatos : '',
          oficina: '0001',
          pantPagina: data && data.pantPagina ? data.pantPagina : '',
          retroceder: false,
          mainUser: appParams.mainUser,
          securityToken: hashToken
        },
        eEntrada: {
          cantpunt: 0,
          cliente: '',
          codcuent: '',
          codcuentf: '',
          codentid: config.entidad,
          codplantilla: codPlantilla,
          codprogr: appProgram,
          cuentasalta: data && data.cuentasalta ? data.cuentasalta : '',
          cuentasko: '',
          cuentasok: '',
          cupasig: data && data.cupasig ? data.cupasig : 0,
          cuputiliz: 0,
          estado: '',
          etiqueta: '',
          idclient: '',
          impminimo: data && data.impminimo ? data.impminimo : 0,
          indblqac: '',
          indblqrd: '',
          numcupact: data && data.numcupact ? data.numcupact : 0,
          nummaxcup: data && data.nummaxcup ? data.nummaxcup : 0,
          tipidcli: ''
        }
      }
    }
    try {
      const response = await HTTP.post(config.endpoints.assignCouponALACU, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('SET_LOADING_ALACU', false)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      } else if (response.data.runServiceResponse.return.retorno === 200) {
        console.log('ERROR')
        return response.data.runServiceResponse.return
      } else if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      } else {
        return response.data.runServiceResponse.return
      }
    } catch (error) {
      commit('SET_LOADING_ALACU', false)
      console.log(error)
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  async getCLCAC ({ commit, rootState }, dat) {
    commit('SET_LOADING_CUPON_CUENTAS_TABLE', true)
    const data = await dat
    const as = state.advancedSearch
    // console.log('getCLCAC data', data)
    // console.log('getCLCAC AS', as)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const codPlantilla = state.codPlantilla
    const appProgram = sessionStorage.getItem('appProgram')
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(appParams.entidad + storageAppToken + appParams.canal)
    const body = {
      runService: {
        opData: {
          avanzar: data && data.avanzar ? 'true' : 'false',
          businesstimeout: '',
          canal: config.canal,
          claveFin: data && data.claveFin ? data.claveFin : 20,
          claveInicio: data && data.claveInicio ? data.claveInicio : 1,
          entidad: config.entidad,
          idioma: state.lang.toUpperCase(),
          indMasDatos: data && data.indMasDatos ? data.indMasDatos : '',
          oficina: '0001',
          pantPagina: data && data.pantPagina ? data.pantPagina : '',
          retroceder: data && data.retroceder ? 'true' : 'false',
          mainUser: appParams.mainUser,
          securityToken: hashToken
        },
        eEntrada: {
          apellido1: '',
          apellido1f: as.apellid1 ? as.apellid1 : '',
          apellido2: '',
          apellido2f: as.apellid2 ? as.apellid2 : '',
          asignar: '',
          cantpunt: '',
          codcuent: '',
          codcuentf: as.loyaltyAccount ? as.loyaltyAccount : '',
          codentid: config.entidad,
          codplantilla: codPlantilla,
          codprogr: appProgram,
          cupasig: '',
          cuputiliz: '',
          descccue: '',
          destipc: '',
          estado: '',
          fechalta: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          idclient: '',
          idclientf: as.idclient ? as.idclient : '',
          indblqac: '',
          indblqrd: '',
          nombre: '',
          nombreidf: as.nombreid ? as.nombreid : '',
          sexof: as.sexo ? as.sexo : '',
          tipidcli: '',
          tipidclif: as.tipidcli ? as.tipidcli : ''
        }
      }
    }
    try {
      const response = await HTTP.post(config.endpoints.getCLCAC, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('SET_LOADING_CUPON_CUENTAS_TABLE', false)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      } else if (response.data.runServiceResponse.return.retorno === 200) {
        console.log('ERROR')
        return response.data.runServiceResponse.return
      } else if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      } else {
        return response.data.runServiceResponse.return
      }
    } catch (error) {
      commit('SET_LOADING_CUPON_CUENTAS_TABLE', false)
      console.log(error)
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  async getCLPCP ({ commit, rootState }, data) {
    commit('LOADING_CLPCP', true)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const appProgram = sessionStorage.getItem('appProgram')
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(appParams.entidad + storageAppToken + appParams.canal)
    const body = {
      runService: {
        opData: {
          avanzar: data && data.avanzar ? data.avanzar : false,
          businesstimeout: '',
          canal: config && config.canal ? config.canal : '',
          claveFin: data && data.claveFin ? data.claveFin : '',
          claveInicio: data && data.claveInicio ? data.claveInicio : '',
          entidad: config && config.entidad ? config.entidad : '',
          idioma: state.lang.toUpperCase(),
          indMasDatos: '',
          oficina: '',
          pantPagina: '',
          retroceder: data && data.retroceder ? data.retroceder : false,
          mainUser: appParams.mainUser,
          securityToken: hashToken
        },
        eEntrada: {
          cod_plantilla: '',
          codentid: config && config.entidad ? config.entidad : '',
          codprogr: appProgram,
          descripcion: '',
          fechafin: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          fechaici: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          imp_minimo: 0,
          num_cup_act: 0,
          num_max_cup: 0
        }
      }
    }
    try {
      const response = await HTTP.post(config.endpoints.getTemplates, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('LOADING_CLPCP', false)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      } else if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      } else {
        return response.data.runServiceResponse.return
      }
    } catch (error) {
      console.log(error)
      commit('LOADING_CLPCP', false)
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  async getTemplateDetails ({ commit, rootState }, data) {
    commit('LOADING_TEMPLATEDETAILS', true)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const codPlantilla = state.codPlantilla
    // console.log('getTemplateDetails codPlantilla', codPlantilla)
    const appProgram = sessionStorage.getItem('appProgram')
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(appParams.entidad + storageAppToken + appParams.canal)
    const body = {
      runService: {
        opData: {
          avanzar: false,
          businesstimeout: '',
          canal: config.canal,
          claveFin: '',
          claveInicio: '',
          entidad: config.entidad,
          idioma: state.lang.toUpperCase(),
          indMasDatos: '',
          oficina: '',
          pantPagina: '',
          retroceder: false,
          mainUser: appParams.mainUser,
          securityToken: hashToken
        },
        eEntrada: {
          cod_plantilla: codPlantilla || '',
          codcanal: '',
          codcom: '',
          codprogr: appProgram,
          des_client: '',
          desc_canal: 0,
          descomer: '',
          descripcion: '',
          fechafin: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          fechaici: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          grupo_com: '',
          idmensaje: '',
          imagen: '',
          imp_bonif: 0,
          imp_comer: 0,
          imp_equival: 0,
          imp_max_bonif: 0,
          imp_minimo: 0,
          ind_activo: '',
          ind_liq_com: 0,
          ind_ptos: 0,
          num_cup_act: 0,
          num_max_cup: 0,
          num_ptos: 0,
          por_bonif: 0,
          por_bonif_com: 0,
          ptos_fijo: 0,
          redondeo: 0,
          reutiliz: 0,
          subtitulo: '',
          tip_cupon: '',
          traspaso: ''
        }
      }
    }
    try {
      const response = await HTTP.post(config.endpoints.getTemplateDetails, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('LOADING_TEMPLATEDETAILS', false)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      } else if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      }
      return response.data.runServiceResponse.return
    } catch (error) {
      console.log(error)
      commit('LOADING_TEMPLATEDETAILS', false)
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  // llamada al servicio de conteo de cupones
  async getCouponCount ({ commit, rootState }, data) {
    commit('LOADING_CUPONESCOUNT', true)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const appProgram = sessionStorage.getItem('appProgram')
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(appParams.entidad + storageAppToken + appParams.canal)
    const body = {
      runService: {
        opData: {
          avanzar: false,
          businesstimeout: '',
          canal: config.canal,
          claveFin: '',
          claveInicio: '',
          entidad: config.entidad,
          idioma: state.lang.toUpperCase(),
          indMasDatos: '',
          oficina: '',
          pantPagina: '',
          retroceder: false,
          mainUser: appParams.mainUser,
          securityToken: hashToken
        },
        eEntrada: {
          apellid1f: data && data.apellid1 ? data.apellid1 : '',
          apellid2f: data && data.apellid2 ? data.apellid2 : '',
          canalusof: data && data.canaluso ? data.canaluso : '',
          codentid: config.entidad,
          codplantillaf1: data && data.plantillasseleccionadas[0] ? data.plantillasseleccionadas[0].cod_plantilla : data.codplantilla1 ? data.codplantilla1 : '',
          codplantillaf2: data && data.plantillasseleccionadas[1] ? data.plantillasseleccionadas[1].cod_plantilla : data.codplantilla1 ? data.codplantilla1 : '',
          codplantillaf3: data && data.plantillasseleccionadas[2] ? data.plantillasseleccionadas[2].cod_plantilla : data.codplantilla1 ? data.codplantilla1 : '',
          codplantillaf4: data && data.plantillasseleccionadas[3] ? data.plantillasseleccionadas[3].cod_plantilla : data.codplantilla1 ? data.codplantilla1 : '',
          codplantillaf5: data && data.plantillasseleccionadas[4] ? data.plantillasseleccionadas[4].cod_plantilla : data.codplantilla1 ? data.codplantilla1 : '',
          codprogr: appProgram,
          idclientf: data && data.idclient ? data.idclient : '',
          nombreidf: data && data.nombreid ? data.nombreid : '',
          tipidclif: data && data.tipidcli ? data.tipidcli : '',
          totacupnoutil: 0,
          totalcupones: 0,
          totcuputiliz: 0
        }
      }
    }
    try {
      const response = await HTTP.post(config.endpoints.getCouponCount, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('LOADING_CUPONESCOUNT', false)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      }
      if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      }
      return response.data.runServiceResponse.return
    } catch (error) {
      console.log(error)
      commit('LOADING_CUPONESCOUNT', false)
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  // llamada al servicio de listado de cupones
  async getCouponDetails ({ commit, rootState }, data) {
    commit('LOADING_CUPONESTABLE', true)
    const config = rootState.appConfig.configFile
    const appParams = JSON.parse(sessionStorage.getItem('appParams'))
    const appProgram = sessionStorage.getItem('appProgram')
    const storageAppToken = sessionStorage.getItem('token')
    const hashToken = utils.SHA256(appParams.entidad + storageAppToken + appParams.canal)
    const body = {
      runService: {
        opData: {
          avanzar: data.avanzar ? data.avanzar : false,
          businesstimeout: '',
          canal: config.canal,
          claveFin: data.claveFin ? data.claveFin : '',
          claveInicio: data.claveInicio ? data.claveInicio : '',
          entidad: config.entidad,
          idioma: state.lang.toUpperCase(),
          indMasDatos: '',
          oficina: '',
          pantPagina: '',
          retroceder: data.retroceder ? data.retroceder : false,
          mainUser: appParams.mainUser,
          securityToken: hashToken
        },
        eEntrada: {
          apellido1: '',
          apellid1f: data.apellid1 ? data.apellid1 : '',
          apellido2: '',
          apellid2f: data.apellid2 ? data.apellid2 : '',
          canaluso: '',
          canalusof: data.canaluso ? data.canaluso : '',
          claveopera: '',
          codcom: '',
          codcuent: '',
          codcuentdest: '',
          codcuentuso: '',
          codcupon: '',
          codentid: '',
          codplantilla: '',
          codplantillaf1: data.plantillasseleccionadas[0] ? data.plantillasseleccionadas[0].cod_plantilla : data.codplantilla1 ? data.codplantilla1 : '',
          codplantillaf2: data.plantillasseleccionadas[1] ? data.plantillasseleccionadas[1].cod_plantilla : data.codplantilla1 ? data.codplantilla1 : '',
          codplantillaf3: data.plantillasseleccionadas[2] ? data.plantillasseleccionadas[2].cod_plantilla : data.codplantilla1 ? data.codplantilla1 : '',
          codplantillaf4: data.plantillasseleccionadas[3] ? data.plantillasseleccionadas[3].cod_plantilla : data.codplantilla1 ? data.codplantilla1 : '',
          codplantillaf5: data.plantillasseleccionadas[4] ? data.plantillasseleccionadas[4].cod_plantilla : data.codplantilla1 ? data.codplantilla1 : '',
          codprogr: appProgram,
          desccuent: '',
          descripcion: '',
          descrip: '',
          fecasig: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          fecliquid: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          fecnotif: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          fecsitua: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          fectranfs: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          fecuso: {
            anno: '',
            dia: '',
            format: '',
            mes: '',
            nombreDia: '',
            nombreMes: '',
            valueDate: ''
          },
          horauso: '',
          idclient: '',
          idclientf: data.idclient ? data.idclient : '',
          impdescuent: 0.0,
          impneto: 0.0,
          impoper: 0.0,
          indliq: '',
          indnotif: '',
          nombre: '',
          nombreidf: data.nombreid ? data.nombreid : '',
          num_reutiliza: 0,
          situacion: '',
          tipcons: data.tipCons ? data.tipCons : 'T',
          tipidcli: '',
          tipidclif: data.tipidcli ? data.tipidcli : '',
          trasnferido: ''
        }
      }
    }
    try {
      const response = await HTTP.post(config.endpoints.getCouponDetails, body)
      sessionStorage.setItem('token', response.data.runServiceResponse.return.securityToken)
      commit('LOADING_CUPONESTABLE', false)
      if (response.data.runServiceResponse.return.retorno === '039') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'La sesión ha expirado. Reinicie el registro.'
        })
      } else if (response.data.runServiceResponse.return.retorno === '021') {
        commit('SET_ERROR', {
          isError: true,
          isFatal: true,
          msg: 'Token de seguridad incorrecto.'
        })
      } else if (response.data.runServiceResponse.return.retorno === '200') {
        return false
      } else {
        return response.data.runServiceResponse.return
      }
    } catch (error) {
      console.log(error)
      commit('LOADING_CUPONESTABLE', false)
      commit('SET_ERROR', {
        isError: true,
        isFatal: false,
        msg: error
      }, { root: true })
    }
  },
  setReloadAccountsToAssign ({ commit }, data) {
    commit('SET_RELOAD_ACCOUNTS_TO_ASSIGN', data)
  },
  setReloadCoupons ({ commit }, data) {
    commit('SET_RELOAD_COUPONS', data)
  },
  setReloadCouponsCount ({ commit }, data) {
    commit('SET_RELOAD_COUPONS_COUNT', data)
  },
  setAdvancedSearchFilters ({ commit }, data) {
    commit('SET_ADVANCED_SEARCH', data)
  },
  setCodPlantilla ({ commit }, data) {
    // console.log('setCodPlantilla', data)
    commit('SET_PLANTILLA', data)
  }
}

// mutations
const mutations = {
  'SET_RELOAD_ACCOUNTS_TO_ASSIGN' (state, actions) {
    state.reloadAccountsToAssign = actions
  },
  'SET_RELOAD_COUPONS' (state, actions) {
    state.reloadCoupons = actions
  },
  'SET_RELOAD_COUPONS_COUNT' (state, actions) {
    state.reloadCouponsCount = actions
  },
  'SET_ADVANCED_SEARCH' (state, actions) {
    state.advancedSearch = actions
  },
  'SET_PLANTILLA' (state, actions) {
    state.codPlantilla = actions
  },
  'LOADING_CLPCP' (state, actions) {
    state.loadingCLPCP = actions
  },
  'LOADING_TEMPLATEDETAILS' (state, actions) {
    state.loadingTemplateDetails = actions
  },
  'LOADING_CUPONESCOUNT' (state, actions) {
    state.loadingCuponesCount = actions
  },
  'LOADING_CUPONESTABLE' (state, actions) {
    state.loadingCuponesTable = actions
  },
  'SET_TYPE_COUPON' (state, actions) {
    state.couponType = actions
  },
  'SET_TYPE_IDECLIENT' (state, actions) {
    state.idclient = actions
  },
  'SET_TYPE_TIPDICLI' (state, actions) {
    state.tipidcli = actions
  },
  'SET_TYPE_NAME' (state, actions) {
    state.nombre = actions
  },
  'SET_TYPE_APELLIDO1' (state, actions) {
    state.apellid1 = actions
  },
  'SET_TYPE_APELLIDO2' (state, actions) {
    state.apellid2 = actions
  },
  'SET_TYPE_CANAL' (state, actions) {
    state.canalusof = actions
  },
  'SET_TYPE_CODPLANTILLA1' (state, actions) {
    state.codplantilla1 = actions
  },
  'SET_TYPE_CODPLANTILLA2' (state, actions) {
    state.codplantilla2 = actions
  },
  'SET_TYPE_CODPLANTILLA3' (state, actions) {
    state.codplantilla3 = actions
  },
  'SET_TYPE_CODPLANTILLA4' (state, actions) {
    state.codplantilla4 = actions
  },
  'SET_TYPE_CODPLANTILLA5' (state, actions) {
    state.codplantilla5 = actions
  },
  'SET_LOADING_ALACU' (state, actions) {
    state.loadingALACU = actions
  },
  'SET_LOADING_CUPON_CUENTAS_TABLE' (state, actions) {
    state.loadingCLCAC = actions
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
